var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0.5C2.68629 0.5 0 3.18629 0 6.5V9.5C0 12.8137 2.68629 15.5 6 15.5H9C12.3137 15.5 15 12.8137 15 9.5V6.5C15 3.18629 12.3137 0.5 9 0.5H6ZM6.66602 9.0537L4.87435 7.26204C4.72157 7.10926 4.52713 7.03287 4.29102 7.03287C4.0549 7.03287 3.86046 7.10926 3.70768 7.26204C3.5549 7.41481 3.47852 7.60926 3.47852 7.84537C3.47852 8.08148 3.5549 8.27593 3.70768 8.4287L6.08268 10.8037C6.24935 10.9704 6.44379 11.0537 6.66602 11.0537C6.88824 11.0537 7.08268 10.9704 7.24935 10.8037L11.1662 6.96712C11.319 6.81434 11.3953 6.6199 11.3953 6.38379C11.3953 6.14768 11.319 5.95323 11.1662 5.80046C11.0134 5.64768 10.819 5.57129 10.5828 5.57129C10.3467 5.57129 10.1523 5.64768 9.99951 5.80046L6.66602 9.0537Z",
    fill: "#9D8DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckA);
export default __webpack_public_path__ + "static/media/check_a.e7d1d9f937839bace7524dec594f31b4.svg";
export { ForwardRef as ReactComponent };